import {UserSummary} from '../../account/modules/user/api/entity/userSummary.model';
import {Moment} from 'moment-timezone';
import {WithPermissionModel} from '../permission/api/entity/withPermission.model';

export abstract class EntityWithCreatedAtMetadata extends WithPermissionModel{
    createdAt: Moment;
    createdBy: UserSummary;
}
